import {Component, OnInit} from '@angular/core';
import {DataService} from '../../../Services/data.service';
import {AppConfigService} from '../../../Services/app-config.service';
import {StorageService} from '../../../Services/storage.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-crm-interactions',
  templateUrl: './crm-interactions.component.html',
  styleUrls: ['./crm-interactions.component.css'],
  standalone: false
})
export class CrmInteractionsComponent implements OnInit {

  isLoading = true;
  interactions: any[] = [];
  totalRecords = 0;
  page = 0;
  pageSize = 25;

  filterType = '';
  filterUserId = '';
  searchText = '';
  users: any[] = [];

  constructor(
    private dataService: DataService,
    private localStorage: StorageService,
    private appConfig: AppConfigService,
    private titleService: Title
  ) {
  }

  ngOnInit(): void {
    this.titleService.setTitle('CRM Interactions');
    this.loadUsers();
    this.loadInteractions();
  }

  loadUsers(): void {
    this.dataService.getApiListData('sys_user', '?pageNumber=0&pageSize=999').subscribe({
      next: (result: any) => {
        this.users = result.Data ?? result.items ?? [];
      }
    });
  }

  get filteredInteractions(): any[] {
    if (!this.searchText) {
      return this.interactions;
    }
    const q = this.searchText.toLowerCase();
    return this.interactions.filter(i =>
      (i.subject ?? '').toLowerCase().includes(q) ||
      (i.entity_name ?? i.entityName ?? '').toLowerCase().includes(q) ||
      (i.user_name ?? '').toLowerCase().includes(q) ||
      (i.body ?? '').toLowerCase().includes(q)
    );
  }

  loadInteractions(): void {
    this.isLoading = true;
    const companyId = this.localStorage.StorageGet('default_company_id', '');
    let params = '?page=' + this.page + '&pageSize=' + this.pageSize;
    if (companyId) {
      params += '&company_id=' + encodeURIComponent(companyId);
    }
    if (this.filterType) {
      params += '&type=' + encodeURIComponent(this.filterType);
    }
    if (this.filterUserId) {
      params += '&user_id=' + encodeURIComponent(this.filterUserId);
    }

    const url = 'crm_interaction' + params;
    this.dataService.getData(url).subscribe({
      next: (result: any) => {
        console.log('crm-interactions result:', result);
        this.interactions = result?.items ?? result ?? [];
        this.totalRecords = result?.total ?? this.interactions.length;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  onFilterChange(): void {
    this.page = 0;
    this.loadInteractions();
  }

  onPageChange(newPage: number): void {
    this.page = newPage;
    this.loadInteractions();
  }

  interactionTypeIcon(type: string): string {
    const map: any = {
      call: 'bi-telephone', email: 'bi-envelope', meeting: 'bi-calendar-event',
      note: 'bi-sticky', demo: 'bi-display', site_visit: 'bi-geo-alt'
    };
    return map[type] ?? 'bi-chat';
  }

  outcomeClass(outcome: string): string {
    if (outcome === 'positive') {
      return 'text-success';
    }
    if (outcome === 'negative') {
      return 'text-danger';
    }
    return 'text-muted';
  }
}
